import { forwardRef } from 'react';

export const PresentationOverlay = forwardRef(function PresentationOverlay(
  { current, currentIndex, totalSlides, onExit },
  presentRef,
) {
  if (current?.type !== 'slide') return null;
  return (
    <div
      ref={presentRef}
      onClick={onExit}
      className="fixed inset-0 z-[100] bg-black flex items-center justify-center cursor-pointer select-none"
      data-testid="presentation-overlay"
    >
      {current.slide?.image_url ? (
        <img
          src={current.slide.image_url}
          alt={current.slide.title || 'Slide'}
          className="max-h-screen max-w-full object-contain"
          draggable={false}
          data-testid="presentation-slide-image"
        />
      ) : (
        <div className="max-w-4xl w-full px-16 text-white space-y-6">
          <h2 className="text-4xl font-semibold">{current.slide?.title || `Slide ${currentIndex + 1}`}</h2>
          {current.slide?.content?.text && (
            <p className="text-xl leading-relaxed text-white/80">{current.slide.content.text}</p>
          )}
          {current.slide?.content?.bullet_points?.length > 0 && (
            <ul className="space-y-3 text-lg text-white/80">
              {current.slide.content.bullet_points.map((bp, bpi) => (
                <li key={`present-bp-${bpi}`} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-white/70 mt-3 shrink-0" />{bp}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      <div className="pointer-events-none absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 text-xs tracking-wide">
        {currentIndex + 1} / {totalSlides} &nbsp;&middot;&nbsp; Use &larr; &rarr; to navigate &nbsp;&middot;&nbsp; Click or press Esc to exit
      </div>
    </div>
  );
});
